import React from "react";

export default function LoadingCard({ label = "読み込み中…" }) {
  return (
    <div className="line-card line-card--loading" role="status" aria-live="polite">
      <div className="line-spinner" aria-hidden />
      <div className="line-loading-text">{label}</div>
    </div>
  );
}
